import {
  Form,
  Input,
  Select,
  TimePicker,
  Checkbox,
  Button,
  Modal,
  message,
  Radio,
  InputNumber,
} from "antd";
import { useState, useEffect, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";

import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const { Option } = Select;
const { TextArea } = Input;

const UpdteWorkLog = ({ visible, handleOk, handleUpdateCancel, workLogId }) => {
  const [form] = Form.useForm();
  const { date } = useParams();
  const [workType, setWorkType] = useState("");
  const [auditors, setAuditors] = useState([]);
  // const [auditAssign, setAuditAssign] = useState([]);
  const [workLogUserId, setWorkLogUserId] = useState("");
  const { user } = useAuth();
  const location = useLocation();
  const firstSegment = location.pathname.split("/").filter(Boolean)[0];
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchAuditors = useCallback(() => {
    axios
      .get(`${apiUrl}/api/auditor/getAuditAdmins`)
      .then((response) => {
        if (response.data.success) {
          setAuditors(response.data.data);
        }
      })
      .catch((error) => console.error("Error fetching auditors:", error));
  }, [apiUrl]);

  const fetchWorkLog = useCallback(() => {
    if (!workLogId) return;
    setLoading(true);
    axios
      .get(`${apiUrl}/api/worklogs/getWorkLogById/${workLogId}`)
      .then((response) => {
        if (response.status === 200) {
          const workLog = response.data.workLog;
          // console.log(workLog, "selected worklog get ")
          form.setFieldsValue({
            userId: workLog.userId || "",
            workType: workLog.workType || "",
            startTime: workLog.startTime ? dayjs(workLog.startTime) : null,
            endTime: workLog.endTime ? dayjs(workLog.endTime) : null,
            description: workLog.description || "",
            reason: workLog.reason || "",
            paidLeave: workLog.paidLeave || false,
            sickLeave: workLog.sickLeave || false,
            initiative: workLog.initiative || "",
            mouType: workLog.mouType || "Non-Mou",
            auditNo: workLog.auditNo || null,
            revenue: workLog.revenue || null,
            auditDetail: workLog.auditDetail || "",
            proposal_number: workLog.proposalNumber || "",
          });
          setWorkType(workLog.workType);
          setWorkLogUserId(workLog.userId);
        }
      })
      .catch((error) => {
        console.error("Error fetching work log:", error);
        message.error("Failed to fetch work log details.");
      })
      .finally(() => setLoading(false));
  }, [workLogId, form, apiUrl]);

  // const fetchAudits = useCallback(() => {
  //   const userIdForWorkLog =
  //     firstSegment === "admin-work-log"
  //       ? workLogUserId || user._id
  //       : user._id;

  //   // console.log(userIdForWorkLog, "userid condition wise get");

  //   if (!userIdForWorkLog) return;

  //   const queryParams = new URLSearchParams({
  //     status: "assigned",
  //     userId: userIdForWorkLog,
  //   }).toString();

  //   axios
  //     .get(`${apiUrl}/api/auditor/getAllAuditsByUserId?${queryParams}`)
  //     .then((response) => {
  //       if (response.data.success) {
  //         setAuditAssign(response.data.data);
  //         // console.log(response.data.data, "audit assign for worklog");
  //       }
  //     })
  //     .catch((error) =>
  //       console.error("Error fetching auditor assign detail", error)
  //     );
  // }, [apiUrl, firstSegment, workLogUserId, user._id]);


  const [proposalNumbers, setProposalNumbers] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      const userIdForWorkLog =
        firstSegment === "admin-work-log"
          ? workLogUserId || user._id
          : user._id;

      if (!userIdForWorkLog) return;

      const queryParams = new URLSearchParams({
        status: "assigned",
        userId: userIdForWorkLog,
      }).toString();

      const [auditRes, proposalRes] = await Promise.all([
        axios.get(
          `${apiUrl}/api/auditor/getAllAuditsByUserId?${queryParams}`
        ),
        axios.get(
          `${apiUrl}/api/proposal/proposal-number/filter-without-services`
        ),
      ]);

      if (auditRes.data.success && proposalRes.data.success) {
        const audits = auditRes.data.data;
        const proposals = proposalRes.data.data;

        //  Extract proposal numbers from audits
        const auditProposalNumbers = audits.map(
          (audit) => audit.proposal_number
        );

        //  Extract proposal numbers from proposals
        const proposalNumbersList = proposals.map(
          (proposal) => proposal.proposal_number
        );

        //  Merge both and remove duplicates
        const uniqueProposalNumbers = [
          ...new Set([...auditProposalNumbers, ...proposalNumbersList]),
        ];

        setProposalNumbers(uniqueProposalNumbers);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  }, [apiUrl, firstSegment, workLogUserId, user._id]);

  useEffect(() => {
    if (visible) {
      fetchAuditors();
      fetchWorkLog();
      // fetchAudits();
      fetchData()
      setIsEditing(false);
      // console.log(auditAssign, "update assign audit ")
    }
  }, [visible, fetchAuditors, fetchWorkLog, fetchData]);
  // console.log(date, "date of update worklog");
  const onFinish = async (values) => {
    // if (values.startTime && values.endTime) {
    //   if (dayjs(values.startTime).isAfter(dayjs(values.endTime))) {
    //     message.error("Start time should be less than end time");
    //     return;
    //   }
    // }

    if (values.startTime && values.endTime) {


      const selectedDate = dayjs(date, "DD-MM-YYYY", true);
      // console.log(selectedDate, date, "date of update worklog on finish");
      if (!selectedDate.isValid()) {
        message.error("Invalid date");
        return;
      }

      const start = selectedDate
        .hour(values.startTime.hour())
        .minute(values.startTime.minute())
        .second(0);

      const end = selectedDate
        .hour(values.endTime.hour())
        .minute(values.endTime.minute())
        .second(0);

      if (start.isAfter(end)) {
        message.error("Start time should be less than end time");
        return;
      }


      console.log(start.toISOString(), "start time");
      // 2025-12-02T04:00:00.000Z

      console.log(end.toISOString(), "end time");
      // 2025-12-02T12:30:00.000Z

      try {
        const data = {
          userId: firstSegment === "admin-work-log" ? values.userId : user._id,
          workType: values.workType,
          // startTime: values.startTime
          //   ? dayjs(values.startTime).toISOString()
          //   : null,
          // endTime: values.endTime ? dayjs(values.endTime).toISOString() : null,

          startTime: start.toISOString(),
          endTime: end.toISOString(),
          date: date, // Use the date from URL params

          description: values.description || "",
          reason: values.reason || "",
          paidLeave: values.paidLeave || false,
          sickLeave: values.sickLeave || false,
          initiative: values.initiative || "",
          mouType: values.mouType || "Non-Mou",
          auditNo: values.auditNo || 0,
          revenue: values.revenue || 0,
          auditDetail: values.auditDetail || "",
          proposalNumber: values.proposal_number || "",
          // date: date,
        };
        console.log("Updating Data:", data); // Debug log
        const response = await axios.put(
          `${apiUrl}/api/worklogs/updateWorkLogById/${workLogId}`,
          data
        );
        if (response.status === 200) {
          message.success("Work log updated successfully");
          console.log("Work log updated successfully:", response.data);
          handleOk();
        }
      } catch (error) {

        const errorMsg =
          error?.message === "Network Error"
            ? "Please check the network connection"
            : "Something went wrong";

        message.error(errorMsg);
        if (error.response && error.response.status === 403) {
          message.error(
            "You do not have permission to update this work log. Please request an admin to update it."
          );
        } else if (error.response.status === 500) {
          message.error("Please check the Network Connection ");
          return;

        } else {
          console.error("Error updating work log:", error);
          message.error("Failed to update work log.");
        }

      }
    }
  };

  return (
    <Modal
      title="Update Work Log"
      open={visible}
      onCancel={() => {
        form.resetFields();
        handleUpdateCancel();
      }}
      footer={null}
    >
      <div className="flex justify-end mb-4">
        {!isEditing && (
          <Button type="primary" onClick={() => setIsEditing(true)}>
            Edit
          </Button>
        )}
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish}>
        {firstSegment === "admin-work-log" && (
          <Form.Item
            name="userId"
            label="Select Auditor"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select User" disabled={!isEditing}>
              {auditors.map((auditor) => (
                <Option key={auditor._id} value={auditor._id}>
                  {auditor.userName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item
          name="workType"
          label="Work Type"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Select Work Type"
            onChange={(val) => setWorkType(val)}
            disabled={!isEditing}
          >
            <Option value="audit">Audit Work</Option>
            <Option value="wfh">WFH</Option>
            <Option value="office">Office</Option>
            <Option value="onDuty">On Duty</Option>
            <Option value="absent">Absent</Option>
          </Select>
        </Form.Item>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            name="startTime"
            label="Start Time"
            rules={[
              {
                required: isEditing && workType !== "absent",
                message: "Start time is required",
              },
            ]}
          >
            <TimePicker
              use12Hours
              format="h:mm A"
              className="w-full"
              // editable only when in edit mode and not absent
              disabled={!isEditing || workType === "absent"}
            />
          </Form.Item>
          <Form.Item
            name="endTime"
            label="End Time"
            rules={[
              {
                required: isEditing && workType !== "absent",
                message: "End time is required",
              },
            ]}
          >
            <TimePicker
              use12Hours
              format="h:mm A"
              className="w-full"
              // editable only when in edit mode and not absent
              disabled={!isEditing || workType === "absent"}
            />
          </Form.Item>
        </div>

        <Form.Item name="description" label="Work Plan / Description" rules={[{ required: true }]}>
          <TextArea
            rows={3}
            placeholder="Enter description"
            disabled={!isEditing || workType === "absent"}
          />
        </Form.Item>

        {/* Initiative & MOU Type in same row */}
        <div className="grid grid-cols-1 gap-4">
          <Form.Item name="initiative" label="Initiative">
            <Select placeholder="Select Initiative" disabled={!isEditing}>
              {/* <Option value="ALL">ALL</Option> */}
              <Option value="HR">HR</Option>
              <Option value="ERC">ERC</Option>
              <Option value="BHOG">BHOG</Option>
              <Option value="CVM">CVM</Option>
              <Option value="CSFH">CSFH</Option>
              <Option value="ERS">ERS</Option>
              <Option value="TPA">TPA</Option>
            </Select>
          </Form.Item>


        </div>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item name="mouType" label="MOU Type">
            <Radio.Group disabled={!isEditing} className="flex justify-around">
              <Radio value="Mou">Mou</Radio>
              <Radio value="Non-Mou">Non-Mou</Radio>
            </Radio.Group>
          </Form.Item>


          {/* <Form.Item
            name="proposal_number"
            label="Proposal Number"
          // rules={[{ required: true, message: "Please select proposal number" }]}
          >
            <Select
              placeholder="Select Proposal Number"
              disabled={!isEditing}
              showSearch
              optionFilterProp="children"
            >
            
              <Select.Option value="NOT_CREATED">
                Proposal Not Created
              </Select.Option>

            
              {proposalNumbers.map((audit) => (
                <Select.Option
                  key={audit._id}
                  value={audit.proposal_number}
                >
                  {audit.proposal_number} ({audit.outlet_name})
                </Select.Option>
              ))}
            </Select>
          </Form.Item> */}

          <Form.Item
            name="proposal_number"
            label="Proposal Number"
          >
            <Select
              placeholder="Select Proposal Number"
              disabled={!isEditing}
              showSearch
              optionFilterProp="children"
            >
              <Select.Option value="NOT_CREATED">
                Proposal Not Created
              </Select.Option>

              {proposalNumbers.map((proposalNo) => (
                <Select.Option key={proposalNo} value={proposalNo}>
                  {proposalNo}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>


        </div>

        {/* Audit No & Revenue in same row */}
        <div className="grid grid-cols-2 gap-4">
          <Form.Item name="auditNo" label="Number of Audits">
            <InputNumber
              className="w-full"
              placeholder="Enter the number of audits"
              disabled={!isEditing}
            />
          </Form.Item>

          <Form.Item name="revenue" label="Revenue">
            <InputNumber
              className="w-full"
              placeholder="Enter revenue amount"
              disabled={!isEditing}
            />
          </Form.Item>
        </div>

        <Form.Item name="auditDetail" label="Work Audit Details">
          <TextArea
            rows={3}
            placeholder="Enter audit details"
            disabled={!isEditing}
          />
        </Form.Item>

        {workType === "absent" && (
          <>
            <Form.Item
              name="reason"
              label="Reason"
              rules={[{ required: true, message: "Reason is required" }]}
            >
              <TextArea
                rows={2}
                placeholder="Enter reason for absence"
                disabled={!isEditing}
              />
            </Form.Item>
            <div className="flex gap-4">
              <Form.Item name="paidLeave" valuePropName="checked">
                <Checkbox disabled={!isEditing}>Paid Leave</Checkbox>
              </Form.Item>
              <Form.Item name="sickLeave" valuePropName="checked">
                <Checkbox disabled={!isEditing}>Sick Leave</Checkbox>
              </Form.Item>
            </div>
          </>
        )}

        {isEditing && (
          <Form.Item>
            <Button type="primary" htmlType="submit" className="w-full">
              Update
            </Button>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default UpdteWorkLog;
